<template>
  <v-container>
    <v-layout row>
      <v-flex xs12 sm6 offset-sm3>
        <h3 class="mt-5 mb-2 mx-1">Create New Agenda</h3>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex xs12>
        <form @submit.prevent="createNewTodo">
          <!-- Select Type -->
          <v-layout row>
            <v-flex xs11 sm6 offset-sm3>
              <v-row cols="12">
                <v-radio-group v-model="type" row>
                  <span class="pl-8 pr-3">Type</span>
                  <v-radio value="event" label="Event" />
                  <v-radio value="task" label="Task" />
                  <v-radio value="todo" label="Todo" />
                </v-radio-group>
              </v-row>
            </v-flex>
          </v-layout>
          <!-- Agenda Title -->
          <v-layout row>
            <v-flex xs12 sm6 offset-sm3>
              <v-col cols="11" lg="12" sm="12">
                <v-text-field
                  v-model="newTodo.title"
                  label="Title*"
                  prepend-icon="event"
                  required
                ></v-text-field>
              </v-col>
            </v-flex>
          </v-layout>

          <!-- Agenda Description -->
          <v-layout row>
            <v-flex xs12 sm6 offset-sm3>
              <v-col cols="11" sm="12" lg="12">
                <v-textarea
                  label="Description"
                  v-model="newTodo.description"
                  prepend-icon="description"
                  rows="3"
                ></v-textarea>
              </v-col>
            </v-flex>
          </v-layout>

          <!-- Pickers for event -->
          <div v-if="type === 'event'">
            <!-- Date-Range -->
            <v-layout row>
              <v-flex col-md-12 col-lg-6 col-11 offset-sm3>
                <v-row>
                  <!-- startDate for event -->
                  <v-col cols="12" md="6">
                    <v-datetime-picker
                      label="Start Time(YYYY-MM-DD 2h Hrs)"
                      v-model="newTodo.startTime"
                      :text-field-props="textProps"
                      :date-picker-props="dateProps"
                    />
                  </v-col>
                  <v-col cols="12" md="6">
                    <!-- endTime for event -->
                    <v-datetime-picker
                      label="End Time(YYYY-MM-DD 2h Hrs)"
                      v-model="newTodo.endTime"
                      :text-field-props="textProps"
                      :date-picker-props="dateProps"
                    />
                  </v-col>
                </v-row>
              </v-flex>
            </v-layout>
          </div>

          <div v-else-if="type === 'task'">
            <v-layout row>
              <v-flex col-sm-12 col-lg-6 col-11 offset-sm3>
                <v-row>
                  <!-- startDate for event -->
                  <v-col cols="12" sm="6">
                    <v-datetime-picker
                      label="Time(YYYY-MM-DD 2h Hrs)"
                      v-model="newTodo.startTime"
                      :text-field-props="textProps"
                      :date-picker-props="dateProps"
                    />
                  </v-col>
                </v-row>
              </v-flex>
            </v-layout>
          </div>

          <!-- Buttons -->
          <v-layout row>
            <v-flex xs12 md6 offset-sm3>
              <v-col>
                <v-btn
                  color="success"
                  class="mx-2"
                  @click="createNewTodo"
                  :disabled="!formIsValid"
                  id="tura"
                  >Save {{type}}</v-btn
                >
                <v-btn color="warning" @click="$back()">Cancel</v-btn>
              </v-col>
            </v-flex>
          </v-layout>
        </form>
      </v-flex>
    </v-layout>
    <!-- snackBar Start -->
    <v-snackbar color="warning" v-model="showDuplicate" :timeout="2000" top>
      Failed to create event, you already have a schedule event at the time
      <template v-slot:action="{ attrs }">
        <v-btn color="success" text v-bind="attrs" @click="snackbar = false"
          >Ok</v-btn
        >
      </template>
    </v-snackbar>
    <!-- snackBar End -->
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      textProps: {
        prependIcon: "event"
      },
      dateProps: {
        min: new Date().toISOString().split("T")[0]
      },
      showDuplicate: false,
      type: "event",
      newTodo: {
        title: null,
        description: null,
        startTime: null,
        endTime: null
      }
    };
  },
  methods: {
    createNewTodo() {
      if (!this.formIsValid) {
        return;
      }
      if (this.type === "event") {
        let extraFilter = {
          $or: [
            {
              $and: [
                {
                  status: "upcoming"
                },
                {
                  startTime: {
                    $lt: this.agendaData.startTime
                  }
                },
                {
                  endTime: {
                    $gt: this.agendaData.startTime
                  }
                }
              ]
            },
            // {
            //   $and: [
            //     {
            //       startTime: {
            //         $lt: this.agendaData.startTime
            //       }
            //     },
            //     {
            //       endTime: {
            //         $lt: this.agendaData.startTime
            //       }
            //     }
            //   ]
            // },
            {
              $and: [
                {
                  startTime: {
                    $gt: this.agendaData.startTime
                  }
                },
                {
                  startTime: {
                    $lt: this.agendaData.endTime
                  }
                }
              ]
            }
          ]
        };
        this.$db.agendas
          .fetchRecords(extraFilter)
          .then(results => {
            console.log({ results, agenda: this.agendaData });
            if (results.docs.length > 0) return (this.showDuplicate = true);
            this.$db.agendas.save(this.agendaData).then(() => {
              this.$store.dispatch("scheduleAgenda", this.agendaData);
              this.$router.push("/agenda/upcoming");
            });
          })
          .catch(err => {
            console.log("fetch error", err);
          });
      } else {
        this.$db.agendas.save(this.agendaData).then(() => {
          this.$store.dispatch("scheduleAgenda", this.agendaData);
          this.$router.push("/agenda/upcoming");
        });
      }
      // let payload = this.newTodo;
      // payload.refKey = Date.now().toString(36);
      // let fullTime = `${payload.date}T${payload.time}`;
      // delete payload.date;
      // delete payload.time;
      // payload.fullTime = this.moment(fullTime).format();
      // this.$store.dispatch("createNewTodo", payload);
      // this.$router.push("/task/upcoming");
    }
  },
  computed: {
    agendaData() {
      const fields = {
        _id: Date.now().toString(36),
        title: this.newTodo.title,
        description: this.newTodo.description,
        eventType: this.type,
        status: "upcoming",
        emailTitle: `Email-${this.profile.userId}-${Date.now().toString(32)}`,
        startTime: new Date().toUTCString()
      };
      if (this.type === "event") {
        fields.startTime = this.newTodo.startTime;
        fields.endTime = this.newTodo.endTime;
        fields.smsTitle = `SMS-${this.profile.userId}-${Date.now().toString(
          32
        )}`;
        if (
          new Date(this.newTodo.endTime).getTime() >
          new Date(this.newTodo.startTime).getTime()
        ) {
          fields.startTime = this.newTodo.endTime;
          fields.endTime = this.newTodo.startTime;
        }
      } else if (this.type === "task") {
        fields.startTime = this.newTodo.startTime;
      }
      return fields;
    },
    validate() {
      if (this.type === "event") {
        return true;
      }
      return false;
    },
    formIsValid() {
      if (this.type === "event") {
        return (
          this.newTodo.title && this.newTodo.startTime && this.newTodo.endTime
        );
      } else if (this.type === "task") {
        return this.newTodo.title && this.newTodo.startTime;
      }
      return this.newTodo.title;
    }
  }
};
</script>
